<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>

        <div v-if="routePartialType === 'full'">
            <div class="page-wrapper">
                <navbar></navbar>

                <div class="main-content-wrapper">
                    <router-view></router-view>
                </div>

                <footer-main></footer-main>
            </div>
        </div>

        <div v-if="routePartialType === 'meta'">
            <div class="main-content-wrapper">
                <router-view></router-view>
            </div>
        </div>

        <v-dialog/>
    </div>
</template>

<script>
    export default {
        name: 'app',
        computed: {
            routePartialType () {
                return this.$route.meta.partialType
            }
        }
    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue